import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP = "919348843331";

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ryb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const formatPrice = (price, mode) => {
  if (mode === "rent") return `₹${Number(price).toLocaleString("en-IN")}/mo`;
  if (price >= 10000000) return `₹${(price / 10000000).toFixed(2)} Cr`;
  if (price >= 100000) return `₹${(price / 100000).toFixed(1)} L`;
  return `₹${Number(price).toLocaleString("en-IN")}`;
};

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;

export default api;
